import { Component, OnInit } from '@angular/core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import { JqueryUtils } from '../../utils/jquery.utils';
import { AccountService } from '../../services/api/account.service';
import { BrokerService } from '../../services/api/broker.service';
import { DataService } from '../../services/data.service';

import * as $ from 'jquery';

import { NotificationService } from '../../services/notification.service';
import { CONSTANTS } from '../../constants';

@Component({
  selector: 'app-brokers',
  templateUrl: './brokers.component.html',
  styleUrls: ['./brokers.component.scss']
})
export class BrokersComponent implements OnInit {

  eye = faEye;
  eyeSlash = faEyeSlash;

  admin: any;
  filter_params = { user: '' }
  deletion_broker: any = null;
  save_broker_params: any =  { header: '', app_id_type: '', mode: '', button_text: '', t_fa_type: '',
    pwd_type: '', cs_type: '', app_id_class: {}, cs_class: {}, pwd_class: {}, t_fa_class: {},
    _id: '', broker_name: -1, app_id: '', client_id: '', client_secret: '', password: '', t_fa: '',
    valid_upto: '', state: '', login_type: -1, client_id_class: {}, app_id_valid: false, 
    client_id_valid: false, client_secret_valid: false,  }
  modalHeader = '';
  users: any = [];
  broker_accounts: any = [];

  brokers = [
    { display_name: "Aliceblue", name: "ALICE_BLUE", _id: 0 },
    { display_name: "Angel", name: "ANGEL_BROKING", _id: 1 }
  ];
  selBroker = [this.brokers[0]];

  lts = [
    { name: "Auto", _id: 0 },
    { name: "Manual", _id: 1 }
  ];
  selLt = [this.lts[0]];

  constructor(private jq: JqueryUtils, private accountService: AccountService, private brokerService: BrokerService,
    private dataService: DataService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.admin = (sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN) == 'true');
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.BROKERS});
    if (this.admin) {
      this.listUsers();
    } else {
      this.listUserBrokers(null);
    }
  }

  listUsers() {
    this.accountService.listAccounts().subscribe((response: any) => {
      if (response.response_code == 1000) {
        let users = []
        for (let i = 0; i < response.accounts.length; i++) {
          let acc = response.accounts[i]
          users.push({
            _id: acc._id,
            full_name: acc.user.full_name,
          })
        }
        this.users = users;
        this.filter_params.user = this.users[0]._id;
        this.listUserBrokers(this.filter_params.user);
      }
    });
  }

  listUserBrokers(acc_id: any) {
    let data: any = { dt: 'details' };
    if (acc_id != null) {
      data['acc_id'] = acc_id;
    }
    this.brokerService.getUserBrokers(data).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let baccs = response.broker_accounts;
        let bacc, bas = [];
        for (let idx = 0; idx < baccs.length; idx++) {
          bacc = baccs[idx];
          bacc.funds_shown = false;
          bas.push(bacc);
        }
        this.broker_accounts = bas;
      }
    });
  }

  onUserChanged() {
    this.listUserBrokers(this.filter_params.user);
  }

  onAdd() {
    this.modalHeader = 'Add User';
    this.jq.openModal('accountModal');
  }

  onActivate(user: any, state: any) {
    let input = { "_id": user._id, "state": state };
    this.accountService.activateAccount(input).subscribe((response: any) => {
      if (response.response_code == 1000) {
        this.notificationService.showAlert(CONSTANTS.SUCCESS, "Channel started successfully");
        this.listUsers();
      }
    });
  }

  getBrokerByName(name: any) {
    let bidx = -1;
    for (let idx = 0; idx < this.brokers.length; idx++) {
      if (this.brokers[idx].name.toLowerCase() == name.toLowerCase()) {
        bidx = idx;
        break;
      }
    }
    if (bidx > -1) {
      return this.brokers[bidx]._id;
    }
    return -1;
  }

  getBrokerDnameByName(name: any) {
    let bidx = -1;
    for (let idx = 0; idx < this.brokers.length; idx++) {
      if (this.brokers[idx].name.toLowerCase() == name.toLowerCase()) {
        bidx = idx;
        break;
      }
    }
    if (bidx > -1) {
      return this.brokers[bidx].display_name;
    }
    return '';
  }

  getLtByConfig(auto_login: any) {
    if (auto_login) {
      return this.lts[0]._id;
    } else {
      return this.lts[1]._id;
    }
  }

  getBrokerNameById(id: any) {
    let bidx = -1;
    for (let idx = 0; idx < this.brokers.length; idx++) {
      if (this.brokers[idx]._id == id) {
        bidx = idx;
        break;
      }
    }
    if (bidx > -1) {
      return this.brokers[bidx].name.toLowerCase();
    }
    return '';
  }

  getLtByType(type: any) {
    let auto_login = false;
    for (let idx = 0; idx < this.lts.length; idx++) {
      if (String(this.lts[idx]._id).toLowerCase() == String(type).toLowerCase()) {
        auto_login = (this.lts[idx].name.toLowerCase() == 'auto');
        break;
      }
    }
    return auto_login;
  }

  addbrokerAccount() {
    this.save_broker_params.header = 'Add Broker';
    this.save_broker_params.app_id_type = 'text';
    this.save_broker_params.t_fa_type = 'text';
    this.save_broker_params.pwd_type = 'text';
    this.save_broker_params.cs_type = 'text';
    this.save_broker_params.app_id_class = { 'bi-eye': 0, 'bi-eye-slash': 0 }
    this.save_broker_params.client_id_class = { 'col-md-3': (this.admin ? 1 : 0), 'col-md-6': (this.admin ? 0 : 1) }
    this.save_broker_params.cs_class = { 'bi-eye': 0, 'bi-eye-slash': 0 }
    this.save_broker_params.pwd_class = { 'bi-eye': 0, 'bi-eye-slash': 0 }
    this.save_broker_params.t_fa_class = { 'bi-eye': 0, 'bi-eye-slash': 0 }
    this.save_broker_params.mode = 'add';
    this.save_broker_params.button_text = 'ADD';
    this.save_broker_params.broker_name = this.brokers[0]._id;
    this.save_broker_params._id = '';
    this.save_broker_params.app_id = '';
    this.save_broker_params.client_id = '';
    this.save_broker_params.client_secret = '';
    this.save_broker_params.password = '';
    this.save_broker_params.t_fa = '';
    this.save_broker_params.login_type = this.lts[1]._id;
    this.save_broker_params.valid_upto = '';
    this.save_broker_params.state = 'active';
    this.jq.openModal('brokerModal');
  }

  updateBrokerAccount(broker: any) {
    this.save_broker_params.header = 'Update Broker';
    this.save_broker_params.app_id_type = 'password';
    this.save_broker_params.cs_type = 'password';
    this.save_broker_params.pwd_type = 'password';
    this.save_broker_params.t_fa_type = 'password';
    this.save_broker_params.app_id_class = { 'bi-eye': 0, 'bi-eye-slash': 1 }
    this.save_broker_params.client_id_class = { 'col-md-3': (this.admin ? 1 : 0), 'col-md-6': (this.admin ? 0 : 1) }
    this.save_broker_params.cs_class = { 'bi-eye': 0, 'bi-eye-slash': 1 }
    this.save_broker_params.pwd_class = { 'bi-eye': 0, 'bi-eye-slash': 1 }
    this.save_broker_params.t_fa_class = { 'bi-eye': 0, 'bi-eye-slash': 1 }
    this.save_broker_params.mode = 'edit';
    this.save_broker_params.button_text = 'UPDATE';
    this.save_broker_params.broker_name = this.getBrokerByName(broker.name);
    this.save_broker_params._id = broker._id;
    this.save_broker_params.app_id = broker.params.app_id;
    this.save_broker_params.app_id_valid = (broker.params.app_id.trim() != "");
    this.save_broker_params.client_id = broker.params.client_id;
    this.save_broker_params.client_id_valid = (broker.params.client_id.trim() != "");
    this.save_broker_params.client_secret = broker.params.client_secret;
    this.save_broker_params.client_secret_valid = (broker.params.client_secret.trim() != "");
    this.save_broker_params.password = broker.params.password;
    this.save_broker_params.t_fa = broker.params.two_fa || '';
    this.save_broker_params.login_type = this.getLtByConfig(broker.params.auto_login);
    this.save_broker_params.valid_upto = broker.subscription_upto;
    this.save_broker_params.state = broker.state;
    this.jq.openModal('brokerModal');
  }

  deleteBrokerAccount(broker: any) {
    this.jq.openModal('brokerDeleteConfirmationModal');
    this.deletion_broker = broker;
  }

  onSelBroker() { }

  saveBroker() {
    if (!this.valid_params()) return;
    if (this.selBroker[0].name.toLowerCase() == 'alice_blue') {
      if (this.save_broker_params.mode == 'edit') {
        let data = {
          _id: this.save_broker_params._id,
          name: this.getBrokerNameById(this.save_broker_params.broker_name),
          params: {
            app_id: this.save_broker_params.app_id,
            client_id: this.save_broker_params.client_id,
            client_secret: this.save_broker_params.client_secret,
            password: this.save_broker_params.password,
            two_fa: this.save_broker_params.t_fa,
            auto_login: this.getLtByType(this.save_broker_params.login_type)
          },
          subscription_upto: this.save_broker_params.valid_upto,
          state: this.save_broker_params.state
        };
        this.brokerService.updateBroker(data).subscribe((response: any) => {
          if (response.response_code == 1000) {
            this.notificationService.showAlert(CONSTANTS.SUCCESS, "Broker Updated Successfully");
            let ba = response.ba;
            let bas = this.broker_accounts;
            let uidx = -1;
            for (let idx = 0; idx < bas.length; idx++) {
              if (ba._id == bas[idx]._id) {
                uidx = idx;
                break;
              }
            }
            if (uidx > -1) {
              bas[uidx] = ba;
            }
            this.broker_accounts = bas;
            this.jq.closeModal('brokerModal')
          }
        });
      } else if (this.save_broker_params.mode == 'add') {
        let data = {
          account_id: this.filter_params.user,
          name: this.getBrokerNameById(this.save_broker_params.broker_name),
          params: {
            app_id: this.save_broker_params.app_id,
            client_id: this.save_broker_params.client_id,
            client_secret: this.save_broker_params.client_secret,
            password: this.save_broker_params.password,
            two_fa: this.save_broker_params.t_fa,
            auto_login: this.getLtByType(this.save_broker_params.login_type)
          },
          subscription_upto: this.save_broker_params.valid_upto,
          state: this.save_broker_params.state
        };
        this.brokerService.addBroker(data).subscribe((response: any) => {
          if (response.response_code == 1000) {
            this.notificationService.showAlert(CONSTANTS.SUCCESS, "Broker Added Successfully");
            let ba = response.ba;
            let bas = this.broker_accounts;
            bas.push(ba);
            this.broker_accounts = bas;
            this.jq.closeModal('brokerModal')
          }
        });
      }
    } else {
      this.notificationService.showAlert(CONSTANTS.ERROR, "Broker not configured")
    }
  }

  deleteBroker(confirmation: any) {
    if (confirmation == 1) {
      let input = { "_id": this.deletion_broker._id };
      this.brokerService.deleteBroker(input).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.jq.closeModal('brokerDeleteConfirmationModal')
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Broker deleted successfully");
          this.listUserBrokers(this.filter_params.user);
        }
      });
    } else {
      this.deletion_broker = null;
      this.jq.closeModal('brokerDeleteConfirmationModal')
    }
  }

  myFunction() {
    var y = (<HTMLInputElement>document.getElementById("myInput")).type
    if (y === "password") {
      y = "text";
    } else {
      y = "password";
    }
  }

  checkBrokerConnection(broker: any) {
    if (this.selBroker[0].name.toLowerCase() == 'alice_blue') {
      let input = { "_id": broker._id };
      this.brokerService.connectBroker(input).subscribe((response: any) => {
        if (response.response_code == 1000) {
          if (response.msg == '') {
            if (!response.auto_login) {
              window.open(response.login_url)
            }
          } else {
            if (response.err == 1) {
              this.notificationService.showAlert(CONSTANTS.ERROR, response.msg);
            } else {
              this.notificationService.showAlert(CONSTANTS.SUCCESS, response.msg);
            }
          }
        }
      });
    } else {
      this.notificationService.showAlert(CONSTANTS.ERROR, "Broker not configured")
    }
  }

  onBrokerChanged() { }

  onLoginTypeChanged() { }

  toggleShowPassword(param: any) {
    let toggleClass = (name: any) => {
      if (keys.indexOf(name) == -1) {
        this.save_broker_params[ckey][name] = 0;
      } else {
        if (this.save_broker_params[ckey][name] == 1) {
          this.save_broker_params[ckey][name] = 0;
        } else {
          this.save_broker_params[ckey][name] = 1;
        }
      }
    }
    let ckey = `${param}_class`;
    let tkey = `${param}_type`;
    let keys = Object.keys(this.save_broker_params[ckey]);
    toggleClass('bi-eye');
    toggleClass('bi-eye-slash');
    if (this.save_broker_params[ckey]['bi-eye'] == 1) {
      this.save_broker_params[tkey] = 'text';
    }
    if (this.save_broker_params[ckey]['bi-eye-slash'] == 1) {
      this.save_broker_params[tkey] = 'password';
    }
  }

  showFundsClicked(baccount: any) {
    let input = { _id: baccount._id };
    this.accountService.getProfile(input).subscribe((response: any) => {
      if (response.response_code == 1000) {
        if (response.funds.available_margin) {
          baccount.funds = response.funds.available_margin;
          baccount.funds_shown = true;
        }
      }
    });
  }

  valueClass(params: any, name: any) {
    if (name == 'app_id') {
      params.app_id_valid = false;
      if (params.app_id.trim() == "") {
        return { 'd-block': 1 };
      }
      params.app_id_valid = true;
    } else if (name == 'client_id') {
      params.client_id_valid = false;
      if (params.client_id.trim() == "") {
        return { 'd-block': 1 };
      }
      params.client_id_valid = true;
    } else if (name == 'client_secret') {
      params.client_secret_valid = false;
      if (params.client_secret.trim() == "") {
        return { 'd-block': 1 };
      }
      params.client_secret_valid = true;
    }
    return { 'd-block': 0 };
  }

  valid_params() {
    let valid: any = true;
    valid = valid && this.save_broker_params.app_id_valid;
    valid = valid && this.save_broker_params.client_id_valid;
    valid = valid && this.save_broker_params.client_secret_valid;
    return valid;
  }
}